import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const appear = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 200px;
`;

/* A ring with one quarter missing, turning. Grey, because a wait is not an event — the blue is for
   the things a person did.

   `backwards` on the fill is the whole trick: the delay holds it at nought opacity rather than at
   its default, so a wait that ends before the third of a second is a wait nobody saw. */
export const Spinner = styled.i`
  width: 20px;
  height: 20px;
  border: 2px solid #e9ecef;
  border-top-color: #adb5bd;
  border-radius: 50%;
  animation:
    ${spin} 700ms linear infinite,
    ${appear} 200ms ease 300ms backwards;
`;
